import React, { useState, useMemo } from "react";
import { MDBTable, MDBTableHead, MDBTableBody, MDBSpinner } from "mdbreact";
import { Th } from "./styled";
import { TABLE_HEADERS } from "./config";
import SecondLayerRow from "./SecondLayerRow";

const StatisticsTable = ({
  data,
  tableConfig,
  choosedSiteId,
  grouping,
  isLoading,
  filterForm,
  dateForm,
  hidedRows,
  setHidedRows,
  addToCSVData,
  onSort,
  sortConfig,
}) => {

  return (
    <MDBTable responsive striped>
      <MDBTableBody>
        {isLoading ? (
          <tr>
            <td colSpan={TABLE_HEADERS.length}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <MDBSpinner small className="spinner-container" />
              </div>
            </td>
          </tr>
        ) : data.length === 0 ? (
          <tr>
            <td colSpan={TABLE_HEADERS.length}>No data</td>
          </tr>
        ) : (
          data.map((row, index) => (
            <SecondLayerRow
              key={row.grouping}
              index={index}
              row={row}
              tableConfig={tableConfig}
              choosedSiteId={choosedSiteId}
              grouping={grouping}
              setHidedRows={setHidedRows}
              hidedRows={hidedRows}
              filterForm={filterForm}
              dateForm={dateForm}
              addToCSVData={addToCSVData}
              onSort={onSort}
              sortConfig={sortConfig}
            />
          ))
        )}
      </MDBTableBody>
    </MDBTable>
  );
};

export default StatisticsTable;
